import API from '@/amplify/api';
import { AiAutoLogGet } from '@/graphql/queries';
import {  AiAutoLogUpdate } from '@/graphql/mutations';

export const getAiAutoLogByTicketId = async (params) => {
    try {
        let res = await API.graphql({
            query: AiAutoLogGet,
            variables: {
                params: {
                    ...params
                }
            },
        });
        return res.data.AiAutoLogGet;
    } catch (err) {
        console.log('getAiAutoLogByTicketId error >>>', err)
        return [];
    }
}


export const updateAiAutoLog = async (requestDto) => {
    try {
        let res = await API.graphql({
            query: AiAutoLogUpdate,
            variables: {
                AiAutoLogUpdateRequestDto: requestDto
            },
        });
        return res.data.AiAutoLogUpdate;
    } catch (err) {
        console.log('updateAiAutoLog error >>>', err)
        return null;
    }
}
